import axios from '../../config/axios';

function index(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.itemsPerPage;
    return axios().get("/stock-journal/stock-adjustment-vouchers", { params })
}

function store(data) {
    return axios().post("/stock-journal/stock-adjustment-vouchers", data);
}

function remove(id, params) {
    return axios().delete(`/stock-journal/stock-adjustment-vouchers/${id}`, {params});
}

function get(id) {
    return axios().get(`/stock-journal/stock-adjustment-vouchers/${id}`);
}

function print(id) {
   return axios().get(`/stock-journal/stock-adjustment-vouchers/${id}/print`, {
        headers: {
            "Accept": "text/html"
        }
   });
}

function states() {
    return axios().get("/stock-journal/stock-issue-voucher-states")
}

function update(data) {
    return axios().put(`/stock-journal/stock-adjustment-vouchers/${data.id}`, data);
}

function post(id) {
    return axios().put(`/stock-journal/stock-adjustment-vouchers/${id}/post`);
}

export default {
    index,
    states,
    store,
    remove,
    print,
    post,
    update,
    get
}